import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import LandscapingIndustry from "@/pages/industries/LandscapingIndustry";
export const Route = createFileRoute("/industries/landscaping")({ head: ({match}) => pageHead(match.pathname), component: () => (<LandscapingIndustry />) });
